import { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useLottie } from 'lottie-react';
import logoAnimation from '../assets/logo-animation.json';

export default function Preloader() {
  const [loading, setLoading] = useState(true);

  const { View } = useLottie({
    animationData: logoAnimation,
    loop: false,
    autoplay: true,
  });

  useEffect(() => {
    // The animation plays for 150 frames at 60fps (2.5 seconds)
    // We add a tiny buffer before triggering the fade-out of the preloader overlay
    const timer = setTimeout(() => {
      setLoading(false);
    }, 2800);

    return () => clearTimeout(timer);
  }, []);

  return (
    <AnimatePresence>
      {loading && (
        <motion.div
          initial={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.8, ease: "easeInOut" }}
          className="fixed inset-0 z-[99999] bg-black flex flex-col items-center justify-center pointer-events-none"
        >
          {/* Logo animation container */}
          <div className="w-64 h-64 md:w-80 md:h-80 -mt-16 flex items-center justify-center">
            {View}
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
